import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";

type Props = {
	align?: "left" | "center" | "right"
	textAlign?: "left" | "center" | "right"
}

export default /*#__PURE__*/_defineComponent({
  __name: 'tool-tip',
  props: {
    align: { default: "center" },
    textAlign: { default: "center" }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();



const isMobile = ref(window.matchMedia("(max-width: 500px)").matches);
onMounted(() => {
	window.addEventListener('resize', () => {
		isMobile.value = window.matchMedia("(max-width: 500px)").matches;
	});
});

const showToolTip = ref(false);


const __returned__ = { isMobile, showToolTip, ref, onMounted }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})